import { Form, Modal, notification, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getCourseById, updateCourseStatus } from "store/slices/coursesSlice";
import { closeModal } from "store/slices/modalsSlice";

const EditCourseStateModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { course, loading } = useSelector((state) => state?.courses);
  const open = isModalOpen && modalType === "edit_course_status";

  useEffect(() => {
    if (open && modalProps?.courseId) {
      dispatch(getCourseById(modalProps?.courseId));
    }
  }, [dispatch, modalProps?.courseId, open]);

  useEffect(() => {
    if (course && open) {
      form?.setFieldsValue({
        state: course?.state,
      });
    }
  }, [form, course, open]);

  const handleCancel = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  const handleOk = async () => {
    try {
      const values = await form?.validateFields();
      await dispatch(
        updateCourseStatus({
          id: modalProps?.courseId,
          state: values?.state,
        })
      )?.unwrap();

      notification?.success({
        message: t("courses.crud.form.status.success"),
        duration: 3,
      });
      handleCancel();
    } catch (error) {
      notification?.error({
        message: t("courses.crud.form.status.error"),
        description: error?.message || t("common.error.generic"),
        duration: 4,
      });
    }
  };

  return (
    <Modal
      title={t("courses.crud.form.status.title")}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      destroyOnClose={true}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="state"
          label={t("courses.crud.form.label.state")}
          rules={[
            {
              required: true,
              message: t("courses.crud.form.status.required"),
            },
          ]}
        >
          <Select>
            <Select.Option value="Future">
              {t("courses.state.future")}
            </Select.Option>
            <Select.Option value="In Progress">
              {t("courses.state.inprogress")}
            </Select.Option>
            <Select.Option value="Finished">
              {t("courses.state.finished")}
            </Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditCourseStateModal;
